import type { SVGProps } from "react";

export function SpinnerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="path-1-inside-1_1059_5332" fill="white">
        <path d="M9.99998 20.5C4.47714 20.5 0 16.0229 0 10.5C0 4.97718 4.47714 0.500031 9.99998 0.500031C15.5228 0.500031 20 4.97718 20 10.5C20 16.0229 15.5228 20.5 9.99998 20.5Z" />
      </mask>
      <g
        clipPath="url(#paint0_angular_1059_5332_clip_path)"
        mask="url(#path-1-inside-1_1059_5332)"
      >
        <g transform="matrix(-0.00999998 0 0 -0.00999998 9.99998 10.5)">
          <foreignObject x="-1300" y="-1300" width="2600" height="2600">
            <div
              style={{
                background:
                  "conic-gradient(from 90deg, rgba(255, 255, 255, 0) 0deg, rgba(255, 255, 255, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M17 10.5C17 14.366 13.866 17.5 9.99998 17.5V23.5C17.1797 23.5 23 17.6797 23 10.5H17ZM9.99998 3.50003C13.866 3.50003 17 6.63403 17 10.5H23C23 3.32032 17.1797 -2.49997 9.99998 -2.49997V3.50003ZM3 10.5C3 6.63403 6.134 3.50003 9.99998 3.50003V-2.49997C2.82029 -2.49997 -3 3.32032 -3 10.5H3ZM-3 10.5C-3 17.6797 2.82029 23.5 9.99998 23.5V17.5C6.134 17.5 3 14.366 3 10.5H-3Z"
        fill="url(#gradient)"
        mask="url(#path-1-inside-1_1059_5332)"
      />
      <defs>
        <clipPath id="paint0_angular_1059_5332_clip_path">
          <path d="M17 10.5C17 14.366 13.866 17.5 9.99998 17.5V23.5C17.1797 23.5 23 17.6797 23 10.5H17ZM9.99998 3.50003C13.866 3.50003 17 6.63403 17 10.5H23C23 3.32032 17.1797 -2.49997 9.99998 -2.49997V3.50003ZM3 10.5C3 6.63403 6.134 3.50003 9.99998 3.50003V-2.49997C2.82029 -2.49997 -3 3.32032 -3 10.5H3ZM-3 10.5C-3 17.6797 2.82029 23.5 9.99998 23.5V17.5C6.134 17.5 3 14.366 3 10.5H-3Z" />
        </clipPath>
      </defs>
    </svg>
  );
}
